<template>
  <v-layout class="auto-current-state" wrap>
    <v-flex xs12 pb-0>
      <h1 class="headline my-3">
        {{ $t('autoCurrentState.title') }} - {{ autoTitle }}
      </h1>
    </v-flex>

    <v-progress-circular
      v-if="loading"
      class="auto-current-state__loading"
      size="50"
      indeterminate
    />

    <div v-else class="auto-current-state__content">
      <current-state-info class="auto-current-state__half" initial-state />
      <current-state-info class="auto-current-state__half" />
    </div>
  </v-layout>
</template>

<script>
import CurrentStateInfo from '@/components/auto/AutoCurrentState/CurrentStateInfo.vue';

export default {
  components: { CurrentStateInfo },
  data: () => ({
    loading: false,
  }),
  computed: {
    autoTitle() {
      return this.$store.getters['auto/getAutoTitle'];
    },
  },
  methods: {
    async fetchAutoStateDates() {
      await this.$store.dispatch('auto/fetchAutoStateDates', {
        autoId: this.$route.params.autoId,
      });
    },
  },
  async created() {
    this.loading = true;
    await Promise.all([
      this.fetchAutoStateDates(),
      this.$store.dispatch('auto/fetchAutosProperties'),
    ]);
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.auto-current-state {
  &__loading {
    margin: 50px auto;
  }
  &__content {
    display: flex;
    width: 100%;
  }

  &__half {
    width: 50%;

    &:first-child {
      padding-right: 15px;
      border-right: 2px solid #ddd;
    }

    &:last-child {
      padding-left: 15px;
    }
  }
}
</style>
